<template>
    <div class="checkbox-container">
        <input
            type = "checkbox"
            :id = "id"
            :checked = "isChecked"
            @change = "emitChecked"
        />
        <label :for="id">{{ label }}</label>
    </div>
</template>

<script>
export default {
    name: 'InputCheckBox',
    props: {
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        checked: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            isChecked: this.checked,
        };
    },
    watch: {
        value(newVal) {
            this.isChecked = newVal;
        }
    },
    methods: {
        emitChecked() {
            this.isChecked = !this.isChecked;
            this.$emit('valueChanged', this.isChecked);
        }
    }
};
</script>

<style scoped>
    .checkbox-container {
        display: flex;
        align-items: center;
    }
    input[type="checkbox"] {
        height: 24px;
        width: 24px;
        margin: 0 16px 0 0;
    }
    label {
        font-size: 12px;
    }
</style>